<template>
  <div class="upload-file-one-wrap">
    <template v-if="!uploadUrl || noPreview">
      <Upload
        :action="import_url"
        :headers="headers"
        :on-error="uploadErr"
        :format="format"
        :on-success="uploadSuccess"
        :on-format-error="formatError"
        :name="type == 'img' ? 'image' : 'file'"
        :show-upload-list="false"
      >
        <div class="upload-btn">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
          <p>点击或者拖拽文件上传</p>
        </div>
      </Upload>
    </template>
    <template v-else>
      <div :style="style" class="look-img" v-if="type == 'img'">
        <img :src="uploadUrl" style="width: 100%" />
        <div class="demo-upload-list-cover">
          <Icon type="ios-eye-outline" @click.native="lookFile"></Icon>
          <Icon type="ios-trash-outline" @click.native="deleteFile"></Icon>
        </div>
      </div>
      <div v-else>
        <a @click="lookFile">查看</a>
        <a @click="deleteFile" style="color: #ed4014; margin-left: 10px">删除</a>
      </div>
    </template>

    <div class="tips">
      {{ tips }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'upload-file-one',
    props: {
      index: {
        type: [String, Number],
        default: 0,
      },
      tips: {
        type: [String],
        default: '* 推荐大小750*800',
      },
      // 文件类型，分为图片和其他， img图片，file文件
      type: {
        type: [String, Number],
        default: 'img',
      },
      path: {
        type: String,
        default: '',
      },
      url: {
        type: String,
        default: '',
      },
      // 不显示预览图
      noPreview: {
        type: Boolean,
        default: false,
      },
      format: {
        type: [Array],
        default: () => [],
      },
    },
    data() {
      return {
        uploadPath: '', // 上传后的path
        uploadUrl: '', // 上传后全路径
      }
    },
    methods: {
      // 上传成功
      uploadSuccess(res,file) {
        if (res.code == 0) {
          this.$Message.success('上传成功')
          this.uploadUrl = res.data.url
          this.uploadPath = res.data.path
          this.$emit('on-success', res)
          this.$emit('on-change', res.data)
          this.$emit('on-all', {
            url: res.data.url,
            path:res.data.path,
            name:file.name,
            extname:file.name.substring(file.name.lastIndexOf(".")+1)
          })
        } else {
          this.$Modal.error({
            title: '系统提示',
            content: res.message,
          })
        }
      },

      // 上传失败
      uploadErr(error, file, fileList) {
        if (file.status_code == 401) {
          localStorage.removeItem('token')
          return this.$router.push({
            name: 'login',
          })
        }
        this.$Modal.error({
          title: '提示',
          content: '文件上传失败，请重试',
        })
        this.$emit('on-error', err)
      },
      formatError() {
        this.$Modal.error({
          title: '提示',
          content: `文件上传失败,请上传${this.format.join(',')}格式的文件`,
        })
      },
      // 查看文件
      lookFile() {
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.target = '_blank'
        a.href = this.uploadUrl
        a.click()
        document.body.removeChild(a)
      },
      // 删除文件
      deleteFile() {
        this.$Modal.confirm({
          title: '提示',
          content: '确认删除文件？',
          onOk: () => {
            this.uploadUrl = ''
            this.uploadPath = ''
            this.$emit('on-delete', this.index)
            this.$emit('on-change', {
              url: this.uploadUrl,
              path: this.uploadPath,
            })
          },
        })
      },
    },
    watch: {
      url(val) {
        this.uploadUrl = this.url
      },
      path(val) {
        this.uploadPath = this.path
      },
    },
    computed: {
      import_url() {
        return this.type == 'img'
          ? process.env.VUE_APP_API_URL + '/admin/upload/image'
          : process.env.VUE_APP_API_URL + '/admin/upload/file'
      },
      headers() {
        return {
          authorization: localStorage.getItem('token'),
        }
      },
    },
    created() {
      // 如果是父组件默认有了值，回填
      if (this.url) {
        this.uploadPath = this.path
        this.uploadUrl = this.url
      }
    },
  }
</script>

<style scoped lang="less">
  .upload-file-one-wrap {
    display: inline-block;
    margin-right: 5px;
    .upload-btn {
      cursor: pointer;
      padding: 20px 20px;
      border-radius: 5px;
      border: 1px dashed #dcdee2;
      text-align: center;
    }
    .upload-btn:hover {
      transition: all 0.2s;
      box-shadow: 2px 2px 24px rgba(0, 0, 0, 0.1);
    }

    .look-img {
      display: flex;
      align-items: center;
      width: 150px;
      height: 150px;
      border: 1px dashed rgba(197, 197, 197, 1);
      text-align: center;
      justify-content: space-evenly;
      position: relative;
      overflow: hidden;
    }

    .demo-upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.6);
      text-align: center;
    }

    .look-img:hover .demo-upload-list-cover {
      display: block;
    }

    .demo-upload-list-cover i {
      line-height: 150px;
      color: #fff;
      font-size: 20px;
      cursor: pointer;
      margin: 0 2px;
    }

    .demo-spin-icon-load {
      animation: ani-demo-spin 1s linear infinite;
    }
  }
</style>
